import { render } from "./LandingPage.vue?vue&type=template&id=28d99486&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=28d99486&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d99486"]])

export default __exports__